<script>
	export let permission;
	export let isAdmin;

	import Dialog from "./Dialog.svelte";
	import { getContext } from "svelte";
	const { open } = getContext("simple-modal");

	let liste = getEntries();
	let newEntry;

	async function getEntries() {
		const res = await fetch(`/api/Wishlist/${permission}/Entries`);
		return await res.json();
	}

	async function add() {
		const res = await fetch(`/api/Wishlist/${permission}/Entries`, {
			method: "POST",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify({ content: newEntry }),
		});
		newEntry = null;
		let entry = await res.json();
		liste = Promise.resolve([entry, ...(await liste)]);
	}

	const removeDialog = (entryId) => {
		console.log("Dialog");
		open(
			Dialog,
			{
				message: "Wirklich löschen?",
				hasForm: false,
				onOkay: remove,
				value: entryId,
			},
			{
				closeButton: false,
				closeOnEsc: false,
				closeOnOuterClick: false,
			}
		);
	};

	async function remove(entryId) {
		console.log("Remove");
		await fetch(`/api/Wishlist/${permission}/Entries/${entryId}`, {
			method: "DELETE",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
		});

		liste = Promise.resolve((await liste).filter((x) => x.id != entryId));
	}

	async function mark(entry) {
		entry.checked = !entry.checked;

		await fetch(`/api/Wishlist/${permission}/Entries/${entry.id}`, {
			method: "PUT",
			headers: {
				Accept: "application/json",
				"Content-Type": "application/json",
			},
			body: JSON.stringify(entry.checked),
		});

		liste = Promise.resolve([
			entry,
			...(await liste).filter((x) => x.id != entry.id),
		]);
	}
</script>

<style>
	:global(.lbl > img) {
		max-height: 150px;
		max-width: 150px;
	}

	.lbl {
		position: relative;
		line-height: 1.2;
		padding: 0.5em 2.5em 0.5em 2em;
		margin: 0 0 0.5em 0;
		border-radius: 2px;
		user-select: none;
		border: 1px solid hsl(240, 8%, 70%);
		background-color: hsl(240, 8%, 93%);
		color: #333;

		display: flex;
		justify-content: center;
		align-items: center;
	}

	input[type="checkbox"] {
		position: absolute;
		left: 0.5em;
		top: calc(50% - 6px);
		margin: 0;
	}

	.remove {
		position: absolute;
		top: 0;
		right: 0.2em;
		width: 2em;
		height: 100%;
		background: no-repeat 50% 50%
			url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23676778' d='M12,2C17.53,2 22,6.47 22,12C22,17.53 17.53,22 12,22C6.47,22 2,17.53 2,12C2,6.47 6.47,2 12,2M17,7H14.5L13.5,6H10.5L9.5,7H7V9H17V7M9,18H15A1,1 0 0,0 16,17V10H8V17A1,1 0 0,0 9,18Z'%3E%3C/path%3E%3C/svg%3E");
		background-size: 1.4em 1.4em;
		border: none;
		transition: opacity 0.2s;
		text-indent: -9999px;
		cursor: pointer;
	}
</style>

{#await liste then entries}
	<h2>Offen</h2>
	{#each entries.filter((t) => !t.checked) as entry}
		<div class="lbl">
			{@html entry.content}
			<input
				type="checkbox"
				checked={entry.checked}
				on:change={() => mark(entry)} />
			{#if isAdmin}
				<button
					class="remove"
					on:click={() => removeDialog(entry.id)}>remove</button>
			{/if}
		</div>
	{/each}

	<h2>Besorgt</h2>
	{#each entries.filter((t) => t.checked) as entry}
		<div class="lbl">
			{@html entry.content}
			<input
				type="checkbox"
				checked={entry.checked}
				disabled={entry.checked && !isAdmin}
				on:change={() => mark(entry)} />
			{#if isAdmin}
				<button
					class="remove"
					on:click={() => removeDialog(entry.id)}>remove</button>
			{/if}
		</div>
	{/each}
	{#if isAdmin}
		<div>
			<div class="lbl">
				Neuer Eintrag:
				<input
					type="text"
					bind:value={newEntry}
					on:keydown={(e) => e.key == 'Enter' && add()} />
				<button
					disabled={newEntry == null || newEntry.trim() == ''}
					on:click={() => add()}>+</button>
			</div>
		</div>
	{/if}
{/await}
